import React from 'react';
import { useSelector } from 'react-redux';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { TcsmStates } from '../../../root/tcsm-model';
import { ReportContext } from '../models';
import { DemographiReports } from './demographic-reports';
import { DomesticReport } from './domestic-report';
import { RegionDioReport } from './region-dio-reports';


export function ReportContent() {
	const context = useSelector<TcsmStates, ReportContext>(state => state.clergyCompReportState.reportContext);
	switch (context) {
		case ReportContext.PROVINCE:
			return <><DomesticReport /><DemographiReports /></>;
		case ReportContext.DIO:
			return <><ContentSpacer> <RegionDioReport /></ContentSpacer><DemographiReports /></>;

		default:
			return null;
	}
}

